import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';

import { GET_EMAIL_WITH_LOGIN_FAILURE, GET_EMAIL_WITH_LOGIN_REQUEST, GET_EMAIL_WITH_LOGIN_SUCCESS } from 'salon/constants';

const fetchUserEmailsBySalon = (salonId) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    authenticated: true,
    config: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
    endpoint: `salon/${salonId}/users/`,
    types: [GET_EMAIL_WITH_LOGIN_REQUEST, GET_EMAIL_WITH_LOGIN_SUCCESS, GET_EMAIL_WITH_LOGIN_FAILURE],
  },
});

// noinspection JSUnusedGlobalSymbols
export default fetchUserEmailsBySalon;
